import { useState } from 'react';
import CreateCreditNoteHeader from './createCrediNoteHeader';
import { getCurrentDate } from '../../../../../utils/dateUtils';
import CreditNoteForm from './creditNoteForm';
import CreditNoteTable from './creditNoteTable';

const SalesCreateCreditNote = () => {
	const [error, setError] = useState({});
	const [creditNote, setCreditNote] = useState({
		customer_id: null,
		credit_note_number: null,
		date: getCurrentDate(),
		credit_note_type: 1,
		amount_paid: 0.0,
		reference: '',
		notes: '',
	});
	const [salesReturnNumbers, setSalesReturnNumbers] = useState([]);
	const [creditNoteTable, setCreditNoteTable] = useState([]);
	const calculateTotalPayment = () => {
		if (creditNote?.credit_note_type === 1) {
			return creditNoteTable?.reduce((total, bill) => Number(total) + Number(bill.amount), 0);
		} else {
			return creditNoteTable?.reduce(
				(total, bill) => Number(total) + Number(bill.excess_payment_amount),
				0,
			);
		}
	};

	const handleDeleteRow = (id) => {
		setCreditNoteTable((prevArray) => prevArray.filter((item) => item.id !== id));
		setSalesReturnNumbers((prevArray) => prevArray.filter((item) => item.id !== id));
	};

	return (
		<div>
			<CreateCreditNoteHeader
				error={error}
				setError={setError}
				creditNote={creditNote}
				salesReturnNumbers={salesReturnNumbers}
				creditNoteTable={creditNoteTable}
				totalAmount={calculateTotalPayment}
			/>
			<CreditNoteForm
				creditNote={creditNote}
				setSalesReturnNumbers={setSalesReturnNumbers}
				salesReturnNumbers={salesReturnNumbers}
				setCreditNote={setCreditNote}
				error={error}
				setError={setError}
				setCreditNoteTable={setCreditNoteTable}
				creditNoteTable={creditNoteTable}
			/>
			{creditNote.credit_note_type !== 3 && (
				<CreditNoteTable
					column={
						creditNote.credit_note_type === 1
							? ['Date Created', 'Sales Return Number', 'Amount', 'Actions']
							: ['Invoice#', 'PR#', 'Total Amount', 'Excess Amount']
					}
					rows={creditNoteTable}
					creditNoteType={creditNote.credit_note_type}
					handleDelete={(id) => {
						if (creditNote.credit_note_type === 1) {
							handleDeleteRow(id);
						}
					}}
				/>
			)}
			<div
				style={{
					position: 'fixed',
					bottom: 0,
					width: '100%',
					backgroundColor: '#fff',
					zIndex: 10,
				}}
			>
				<div
					style={{
						borderTop: '1px solid #C3CBDC',
						backgroundColor: '#DADDEC',
						boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
						width: '100%',

						height: '100px',
					}}
				>
					<div
						className="max-w-1297"
						style={{ padding: '0rem 2rem 0' }}
					>
						<div
							style={{
								padding: '1rem 2rem 0',
								display: 'flex',
								height: '100px',
								justifyContent: 'flex-end',
								alignItems: 'center',
							}}
						>
							<div
								style={{
									fontWeight: 600,
									fontSize: '20px',
									marginRight: '75px',
								}}
							>
								<p style={{ margin: 0 }}>
									Credit Total: ₹
									{creditNote?.credit_note_type !== 3
										? calculateTotalPayment().toFixed(2)
										: creditNote?.amount_paid}
									/-
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default SalesCreateCreditNote;
